export default __webpack_public_path__ + "static/media/g2022-plan1.12c12bb4.png";